import { SettingsRoutes } from '@app/modules/settings/routing/SettingsRoutes';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { IconButton } from '@mui/material';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { notificationPreferencesTitleMessage } from '../../preferences/notification-preferences-messages';
import { useNotificationsPopoverClose } from '../useNotificationsPopoverClose';

const preferencesIconButtonSx = {
  p: 0.5,
  color: 'text.disabled',
  '&:hover': { color: 'text.secondary' },
  '& .MuiSvgIcon-root': { fontSize: 16 },
} as const;

/**
 * Icon link to notification preferences from the feed header.
 * Closes the sidenav notifications popover when navigating.
 */
export function NotificationFeedPreferencesLink() {
  const $t = useIntl().formatMessage;
  const onClose = useNotificationsPopoverClose();

  return (
    <IconButton
      component={Link}
      to={SettingsRoutes.ROUTES.notifications}
      onClick={() => onClose?.()}
      size="small"
      title={$t(notificationPreferencesTitleMessage)}
      sx={preferencesIconButtonSx}
    >
      <SettingsOutlinedIcon />
    </IconButton>
  );
}
